import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { dataGridModel, queryClient as qc } from 'keys';
import { assessmentLibraryHooks } from '.';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { getAssessmentDefsFetch, getAssessmentsFetch } from 'store/middlewares/assessment.crud';
import { initialPage, initialPageSize } from 'keys/pagination';
import { Table } from 'components';
import { WrapDataGrid } from 'components/DataGrid/Style';
import { isEmpty } from 'lodash';
import { AbilityContext } from 'components/Permissions/Can';
import { LibraryHeaderStyles, AssessmentLibraryStyles } from './Style';
import { LightButton, TablePageStyles } from 'styles/GlobalStyle';
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader';

const AssessmentLibrary = () => {
    const ability = useContext(AbilityContext)
    const isSuperuser = ability.can("manage", "super-user")
    const [assessmentFilters, setAssessmentFilters] = useState({})
    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)

    const [page, setPage] = useState(initialPage)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")

    const filterSchema = {
        primary: [
            { key: "categories" },
            { key: "assessment_defs" }
        ]
    }

    const columns = assessmentLibraryHooks.useColumns()
    const createAssessmentDefBtn = assessmentLibraryHooks.useCreateAssessmentDefBtn()

    const assessmentDefOptions = queryOptions({
        queryKey: [qc.assessmentDefs, "assessment-library", page, pageSize, sorting, assessmentFilters, searchVal],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentDefsFetch({ assessmentFilters, signal, page, pageSize, sorting, search: searchVal, model: qc.assessmentDefs })
            return data
        },
        refetchOnMount: false
    })

    const assessmentDefs = useQuery(assessmentDefOptions)

    useEffect(() => {
        setPage(initialPage)
    }, [headerFilters])

    return (
        <AssessmentLibraryStyles>
            <LibraryHeaderStyles>
                <div>
                    <LightButton  {...createAssessmentDefBtn} />
                </div>
            </LibraryHeaderStyles>
            <TablePageStyles>
                <Table
                    filterSchema={filterSchema} // הטבלה תעביר את זה ל-FilterManager
                    filterValues={assessmentFilters}
                    onFilterChange={setAssessmentFilters}
                    withTitle
                    loading={assessmentDefs.isFetching || isEmpty(assessmentDefs.data)}
                    data={assessmentDefs.data}
                    columns={columns}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    searchVal={searchVal}
                    setSearchVal={setSearchVal}
                    sorting={sorting}
                    setSorting={setSorting}
                    queryKey={assessmentDefOptions.queryKey}
                    visibilityModelKey={dataGridModel.assessment_library}
                />
            </TablePageStyles>
        </AssessmentLibraryStyles>
    );
}

export default AssessmentLibrary

